// extracted by mini-css-extract-plugin
export default {"container":"_1ETszSehzsMQ3g2BPV5mKT","icon":"_5NTPBhjmfML8xk15lu5M83"};